import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%'
  },

  border: {
    borderBottom: `2px solid ${theme.palette.divider}`,
    paddingBottom: '0.5rem'
  },

  row: {
    paddingBottom: '0.25rem'
  },

  input: {
    outline: 'none',
    border: 'none',
    width: '100%'
  },

  controls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '0.75rem'
  },

  delete: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: theme.size.lg,
    color: theme.palette.primary.main
  },

  normalControls: {
    display: 'flex',
    alignItems: 'center',

    '& > :last-child': {
      marginLeft: '0.5rem'
    }
  },

  button: {
    width: 'auto',
    padding: '0 1rem',
    fontSize: theme.size.sm
  },

  complexEdit: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm
  },

  noBorderRow: {
    borderBottom: 'none'
  },

  shortInput: {
    width: '25%'
  },

  editDropdown: {
    border: `1px solid ${theme.border.outline}`,
    marginRight: '1rem',
    textTransform: 'capitalize',
    padding: '0.25rem',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '0.5rem'
  },

  icon: {
    height: '1rem',
    width: '1rem'
  },

  banner: {
    backgroundColor: theme.palette.banner.alert,
    borderRadius: '5px'
  },

  editUserTypeContainer: {
    display: 'flex'
  },

  editUserTypeCheckbox: {
    borderBottom: ' 2px solid #F1F1F1',
    marginBottom: 10,
    paddingBottom: '0.25rem'
  },

  disabledEditUserTypeCheckbox: {
    cursor: 'not-allowed'
  }
}))

export default useStyles
